import app from "../../../../firebase";
import { getAI, getGenerativeModel, VertexAIBackend } from "firebase/ai";

const ai = getAI(app, { backend: new VertexAIBackend() });
// Create a `GenerativeModel` instance with the gemini-2.0-flash model
const model = getGenerativeModel(ai, {
  model: "gemini-2.0-flash-lite-001",
});

// Converts a File or Blob object to a Part object for Gemini API
async function fileToGenerativePart(file) {
  const base64EncodedDataPromise = new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result.split(",")[1]);
    reader.readAsDataURL(file);
  });
  return {
    inlineData: { data: await base64EncodedDataPromise, mimeType: file.type },
  };
}

/**
 * Summarize a file using Gemini 2.0 Flash model.
 * @param {Blob} fileBlob - The file blob to summarize.
 * @param {string} prompt - Optional prompt text for summarization.
 * @returns {Promise<string>} - The generated summary text.
 */
export async function summarizeFileWithGemini(
  fileBlob,
  prompt = "Please summarize the content of this document."
) {
  try {
    console.log("Starting Gemini summarization...");
    const filePart = await fileToGenerativePart(fileBlob);
    const result = await model.generateContent([prompt, filePart]);
    const response = result.response;
    const summaryText = response.text();
    console.log("Gemini summary produced:", summaryText);
    return summaryText;
  } catch (error) {
    console.error("Gemini summarization error:", error);
    console.error("Error details:", error.code, error.message); // Add specific error details
    throw error;
  }
}

/**
 * Summarize multiple files using Gemini 2.0 Flash model.
 * @param {Blob[]} fileBlobs - Array of file blobs to summarize.
 * @param {string} prompt - Optional prompt text for summarization.
 * @returns {Promise<string>} - The generated overview summary text.
 */
export async function summarizeMultipleFilesWithGemini(
  fileBlobs,
  prompt = "Please summarize the overall content of these document pages."
) {
  try {
    console.log("Starting Gemini multi-file summarization...");
    const parts = [];
    for (const fileBlob of fileBlobs) {
      const part = await fileToGenerativePart(fileBlob);
      parts.push(part);
    }
    const result = await model.generateContent([prompt, ...parts]);
    const response = result.response;
    const summaryText = response.text();
    console.log("Gemini multi-file summary produced:", summaryText);
    return summaryText;
  } catch (error) {
    console.error("Gemini multi-file summarization error:", error);
    console.error("Error details:", error.code, error.message);
    throw error;
  }
}
